import { render, staticRenderFns } from "./document-center-left.vue?vue&type=template&id=714a4c52&scoped=true&"
import script from "./document-center-left.vue?vue&type=script&lang=js&"
export * from "./document-center-left.vue?vue&type=script&lang=js&"
import style0 from "./document-center-left.vue?vue&type=style&index=0&id=714a4c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714a4c52",
  null
  
)

export default component.exports